import React from "react";
import Home from "./components/Home";

const App = () => (
  <div>
    <Home />
  </div>
);

export default App;
